import axiosInstance from './AxiosInstance';

const DepositInterestService = {
  // 1. Add Interest Payment to Transaction History
  addInterestPayment: async (interestData) => {
    try {
      const response = await axiosInstance.post('/transaction-history/add-interest', interestData);
      return { 
        success: response.data.success, 
        data: response.data.data, 
        message: response.data.message 
      };
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.message || 'Failed to add interest payment',
        errors: error.response?.data?.errors || []
      };
    }
  },

  // 2. Get All Interest Payments (for listing page)
  getAllInterestPayments: async (params = {}) => {
    try {
      const queryParams = new URLSearchParams();
      if (params.page) queryParams.append('page', params.page);
      if (params.limit) queryParams.append('limit', params.limit);
      if (params.depositorId) queryParams.append('depositorId', params.depositorId);
      if (params.branchId) queryParams.append('branchId', params.branchId);
      if (params.startDate) queryParams.append('startDate', params.startDate);
      if (params.endDate) queryParams.append('endDate', params.endDate);
      if (params.search) queryParams.append('search', params.search);
      if (params.historyType) queryParams.append('historyType', params.historyType);
      const response = await axiosInstance.get(`/transaction-history?${queryParams.toString()}`);
      return {
        success: response.data.success,
        data: response.data.data.data,
        pagination: response.data.data.pagination,
        message: response.data.message
      };
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.message || 'Failed to fetch interest payments',
        data: [],
        pagination: {}
      };
    }
  },

  // 3. Get Interest Payment by ID
  getInterestPaymentById: async (id) => {
    try {
      const response = await axiosInstance.get(`/transaction-history/${id}`);
      return { 
        success: response.data.success, 
        data: response.data.data, 
        message: response.data.message 
      };
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.message || 'Failed to fetch interest payment',
      };
    }
  },

  // 4. Get Interest Summary (for dashboard widgets)
  getInterestSummary: async (params = {}) => {
    try {
      const queryParams = new URLSearchParams();
      if (params.branchId) queryParams.append('branchId', params.branchId);
      if (params.startDate) queryParams.append('startDate', params.startDate);
      if (params.endDate) queryParams.append('endDate', params.endDate);
      
      const response = await axiosInstance.get(`/transaction-history/interest-summary?${queryParams.toString()}`);
      return { 
        success: response.data.success, 
        data: response.data.data, 
        message: response.data.message 
      };
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.message || 'Failed to fetch interest summary',
        data: {}
      };
    }
  },

  // 5. Get Depositors for Interest Payment Dropdown
  getDepositorsForInterest: async (branchId) => {
    try {
      const response = await axiosInstance.get(`/depositors/for-interest?branchId=${branchId}`);
      return { 
        success: response.data.success, 
        data: response.data.data, 
        message: response.data.message 
      };
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.message || 'Failed to fetch depositors',
        data: []
      };
    }
  },

  // 6. Get deposit interest statistics
  getDepositInterestStatistics: async (params = {}) => {
    try {
      const queryParams = new URLSearchParams();
      if (params.companyId) queryParams.append('companyId', params.companyId);
      if (params.branchId) queryParams.append('branchId', params.branchId);
      if (params.historyType) queryParams.append('historyType', params.historyType);
      const url = `/statistics/deposit-interest${queryParams.toString() ? `?${queryParams.toString()}` : ''}`;
      const response = await axiosInstance.get(url);
      
      return {
        success: response.data.success,
        data: response.data.data,
        message: response.data.message
      };
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.message || 'Failed to fetch deposit interest statistics',
        data: {
          totalPayments: 0,
          totalAmount: 0,
          todayPayments: 0,
          todayAmount: 0
        }
      };
    }
  }
};

export default DepositInterestService;